import $ from 'cash-dom';

export default () => {
  const $button = $('.js-show-categories');
  const $menu = $('.js-categories');

  $button.on('click', (e) => {
    const $this = $(e.currentTarget);

    if ($this.hasClass('is-active')) {
      $menu.removeClass('is-active');
      $this.removeClass('is-active');
    } else {
      $menu.addClass('is-active');
      $this.addClass('is-active');
    }
  });
};
